import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn class joiner (app-level, per D3 — the library never imports this). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
